import {css} from '@emotion/css';

import {colours, spacing} from '../../../styles/js/variables';

const styles = {
  container: css`
    label: currentUser__container;
    display: inline-flex;
    align-items: center;
    padding: 0.2rem; // stylelint-disable-line sh-waqar/declaration-use-variable
    color: ${colours.font.ASSISTIVE};
  `,
  initial: css`
    label: currentUser__initial;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    margin-right: ${spacing.XXS};
    color: ${colours.general.WHITE};
    text-transform: uppercase;
    background-color: ${colours.font.LIGHT_GRAY};
    border-radius: 50%;

    :last-child {
      margin-right: 0;
    }
  `,
};

export default styles;
